import type { IntegratedAccount } from './accounts';
import { Select } from '@shared/widgets/select';
import { Button, Table, TableCellType } from '@shared/widgets';

interface IAccountTableProps {
  accounts: IntegratedAccount[];
  isLoading?: boolean;
  categories: string[] | undefined;
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangeCategory: ({ accountId, category }: { accountId: number; category: string }) => void;
  onConnect: (row: IntegratedAccount) => void;
  onDisconnect: (row: IntegratedAccount) => void;
  onChangeCountItemPage: (count: number) => void;
  onChangePage: (index: number) => void;
}

export const IntegrationAccountTable = (props: IAccountTableProps) => {
  return (
    <Table
      columns={['Account', 'Currency', 'Category']}
      items={props.accounts.map((row) => {
        return [
          { type: TableCellType.Text, value: row.accountNumber },
          { type: TableCellType.Text, value: row.currency },
          {
            type: TableCellType.Custom,
            value: (
              <div className='w-fit'>
                <Select
                  items={props.categories || []}
                  nullValue={{ isEnable: false, text: 'Define the category' }}
                  value={row.editCategory || row.integration?.category}
                  disabled={row.integration?.connected}
                  onChange={(val) =>
                    props.onChangeCategory({
                      accountId: row.id,
                      category: val!,
                    })
                  }
                />
              </div>
            ),
          },
          {
            type: TableCellType.Custom,
            value: (
              <div className='flex justify-end'>
                {row.editCategory || (row.integration && !row.integration.connected) ? (
                  <Button className='min-w-32' color='primary' onClick={() => props.onConnect(row)}>
                    Connect
                  </Button>
                ) : row.integration?.category ? (
                  <Button className='min-w-32' color='outlined' onClick={() => props.onDisconnect(row)}>
                    Disconnect
                  </Button>
                ) : (
                  <Button className='min-w-32' color='primary' disabled>
                    Connect
                  </Button>
                )}
              </div>
            ),
          },
        ];
      })}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
      isLoading={props.isLoading}
    />
  );
};
